import { createFileRoute, redirect } from '@tanstack/react-router'

import { authLoginGoogle } from '@/services/auth/auth.gql'
import { useAuth } from '@/services/auth/auth.store'

// const searchParams = z.object({
//   accessToken: z.string().optional(),
// })

export const Route = createFileRoute('/auth/callback')({
  loaderDeps: ({ search }) => ({ search: search as Record<string, string> }),
  loader: async ({ deps }) => {
    const search = deps.search
    const { login, isAuthenticated } = useAuth.getState()

    if (isAuthenticated) {
      throw redirect({ to: '/', replace: true })
    }

    const sp = new URLSearchParams(location.hash)
    const accessToken =
      search?.code ||
      search?.acces_token ||
      sp.get('#access_token') ||
      sp.get('access_token')

    if (!accessToken) {
      throw redirect({ to: '/auth/login' })
    }

    const res = await authLoginGoogle
      .api({
        req: { access_token: accessToken },
      })
      .catch((err) => {
        console.error(err)
        throw redirect({ to: '/auth/login' })
      })

    const { token, user } = res.loginWithGoogle

    if (!token) {
      return {
        status: 'failed',
      }
    }

    await login(token)

    if (!user.confirmation) {
      throw redirect({ to: '/auth/verification', replace: true })
    }

    throw redirect({ to: '/', replace: true })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/auth/callback"!</div>
}
